import React from "react";
import { useLocation } from "react-router-dom";
import { Settings, Mic2, Tv, Ticket, LogOut } from "lucide-react";

const LINKS = [
  { to: "/admin", label: "Beheer", Icon: Settings },
  { to: "/host", label: "Presentator", Icon: Mic2 },
  { to: "/studio", label: "TV-scherm", Icon: Tv, newTab: true },
  { to: "/", label: "Koopsite", Icon: Ticket, newTab: true },
];

export function AdminNav() {
  const { pathname } = useLocation();
  const logout = () => { localStorage.removeItem("host_pin"); window.location.reload(); };
  return (
    <nav data-testid="admin-nav" className="flex flex-wrap items-center gap-1 p-1.5 rounded-xl bg-[#12141D] border border-white/10 w-fit">
      {LINKS.map(({ to, label, Icon, newTab }) => {
        const active = pathname === to;
        return (
          <a key={to} href={to} target={newTab ? "_blank" : undefined} rel={newTab ? "noreferrer" : undefined}
             data-testid={`nav-${label.toLowerCase().replace(/[^a-z]/g, "")}`}
             className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider transition-colors ${
               active ? "bg-[#FFD700] text-[#0B0C10]" : "text-slate-300 hover:bg-white/5 hover:text-white"}`}>
            <Icon className="w-3.5 h-3.5" /> {label}
          </a>
        );
      })}
      <button onClick={logout} data-testid="nav-logout" title="Uitloggen"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider text-slate-500 hover:text-[#FF1744] hover:bg-[#FF1744]/10 transition-colors">
        <LogOut className="w-3.5 h-3.5" /> Uitloggen
      </button>
    </nav>
  );
}
